var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "bundle-wrap bundle-wrap-left bundle-composition",
      class: { "not-carousel": _vm.products.length === 1 },
    },
    [
      _c("div", { staticClass: "bg-wrap" }, [
        _c("div", { staticClass: "bg bg-img", style: _vm.contentBgStyle }),
        _vm._v(" "),
        _c("div", { staticClass: "bg bg-dimmed" }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "composition-state" }, [
        _c("span", { staticClass: "composition-total" }, [
          _vm._v("총 " + _vm._s(_vm.productTotal) + "과목"),
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "composition-paging" }, [
          _vm._v(_vm._s(_vm.slideCurrent + " / " + _vm.products.length)),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "composition-carousel" },
        [
          _vm.products.length === 1
            ? _c(
                "ul",
                _vm._l(_vm.products[0], function (product) {
                  return _c("bundle-product", {
                    key: product.id,
                    attrs: { product: product },
                  })
                }),
                1
              )
            : _c(
                "VueSlickCarousel",
                {
                  attrs: { infinite: false },
                  on: { afterChange: _vm.setPageNum },
                },
                _vm._l(_vm.products, function (productGroup, idx) {
                  return _c(
                    "ul",
                    { key: idx },
                    _vm._l(productGroup, function (product) {
                      return _c("bundle-product", {
                        key: product.id,
                        attrs: { product: product },
                      })
                    }),
                    1
                  )
                }),
                0
              ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.goods
        ? _c("div", { staticClass: "goods" }, [
            _c(
              "div",
              {
                staticClass: "goods-inner",
                style: { border: "1px solid " + _vm.pointColorRGBA },
              },
              [
                _c(
                  "span",
                  {
                    staticClass: "goods-icon",
                    style: { backgroundColor: _vm.pointColor },
                  },
                  [_vm._v("추가구성")]
                ),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass: "goods-desc",
                    style: { color: _vm.pointColor },
                  },
                  [_vm._v(_vm._s(_vm.goods.title))]
                ),
              ]
            ),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }